import React from 'react'
import CustRelationService from '../Service/custRelationService'
import FormInput from './formInput'
import ModalHapus from './modalHapus'
// import ModalHapusError from './modalHapusError'
import ModalBerhasilSimpan from './modalBerhasilSimpan'
import ModalBerhasilUbah from './modalBerhasilUbah'
import ModalHapusBerhasil from './modalHapusBerhasil'
import './custrelation.css'
import { config } from '../Config/config'


export default class index extends React.Component {

    CustRelationModel = {
        _id: "",
        name: "",
        created_by: localStorage.getItem(config.userid),
        // created_on: new Date(),
        // created_on: "",
        // modified_by: "",
        // modified_on: "",
        // deleted_by: "",
        // deleted_on: "",
        is_delete: false

    }

    constructor() {
        super()
        this.state = {
            List: [],
            Model: this.CustRelationModel,
            Mode: "",
            ShowModal: false,
            ShowModalDel: false,
            ShowModalBerhasilSimpan: false,
            ShowModalBerhasilUbah: false,
            errors: {},
            filter: {
                search: '',
                // search :'ibu',
            }

        }
    }

    //function untuk mengambil semua data di DB Variant di backend
    //memanggil API
    loadlist = async () => {
        // const respond = await CustRelationService.getAll()
        const respond = await CustRelationService.getAll(this.state.filter)
        console.log(respond)

        if (respond.success) {
            this.setState({
                List: respond.result,
            })
        }
        // console.log(this.state.List)
    }

    componentDidMount() {
        this.loadlist()
        // console.log(this.VariantModel)
        //untuk cek CategoryModel udah ada di inspect browser
    }

    //funct untuk masukan input ke VariantModel
    //buat simpan data semendata dari form input
    //
    changeHandler = name => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                // ... => agar sesuai dgn paket CustRelationModel
                [name]: value
            }
        })
    }

    //function untuk CHECKED
    checkedHandler = field => ({ target: { checked } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: checked
            }
        })
    }


    //button submit
    saveHandler = async () => {
        console.log(this.state.Mode)
        const respons = await CustRelationService.cekRelasiByName(this.state.Model.name)
        var name = {}
        if (respons.success) {
            name = respons.result
        }

        if (this.state.Mode == "Hapus Relasi") {
            // alert("im here")

            this.state.Model.is_delete = true
            //mengubah is_delete yang dihapus dari false menjadi true
            //hilang dr output, masih ada di db
            // console.log(this.state.Model)

            const respond = await CustRelationService.editDataDelete(this.state.Model)
            console.log(respond)
            if (respond.success) {
                // alert("Succes Delete Data")
                this.setState({
                    Model: this.CustRelationModel,
                    ShowModalDel: false,
                    ShowModalDelBerhasil: true,

                })
                this.loadlist()
            }

        }
        else if (this.handleValidation(name)) {
            if (this.state.Mode == "Ubah Relasi") {
                const respond = await CustRelationService.editData(this.state.Model)
                if (respond.success) {
                    // alert("Success Update Data")
                    this.setState({
                        Model: this.CustRelationModel,
                        ShowModal: false,
                        ShowModalBerhasilUbah: true,
                    })
                    this.loadlist()

                }
            } else {
                const respond = await CustRelationService.addData(this.state.Model)
                console.log(respond)
                if (respond.success) {
                    // alert("Succes Save Data")
                    this.setState({
                        Model: this.CustRelationModel,
                        ShowModal: false,
                        ShowModalBerhasilSimpan: true,
                    })
                    this.loadlist()
                }
            }
        } 

        // }
        // else {
        //     // alert("Form has errors")
        // }
    }


    //button EDIT
    editHandler = async (_id) => {
        const respond = await CustRelationService.getById(_id)

        console.log(respond)

        this.setState({
            Mode: "Ubah Relasi",
            ShowModal: true
        })

        if (respond.success) {
            this.setState({
                Model: respond.result
            })
        }
    }

    //button DELETE
    deleteHandler = async (_id) => {
        // console.log(_id)

        const respond = await CustRelationService.deleteData(_id)
        this.setState({
            ShowModalDel: true
        })
        if (respond.success) {
            alert("Success Delete Data")
            this.loadlist()
        }
    }

    //button DELETE 2
    // deleteHandler2 = async () => {
    //     const respond = await CustRelationService.deleteData(this.state.Model._id)

    //     if (respond.success) {
    //         alert("Success Delete Data")
    //         this.loadlist()
    //         this.setState({
    //             ShowModalDel: false
    //         })
    //     }
    // }

    createHandler = () => {
        this.setState({
            Mode: "Tambah Relasi",
            ShowModal: true,
            // ShowModalBerhasilSimpan: true,
            Model: this.CustRelationModel
        })
        console.log(this.state.ShowModal)

    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            ShowModal: false,
            ShowModalDel: false,
            ShowModalBerhasilSimpan: false,
            ShowModalBerhasilUbah: false,
            ShowModalDelBerhasil: false,
            errors: {},
        })
    }

    //filter
    filterHandler = field => ({ target: { value } }) => {
        //setState untuk mengupdate
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    handleValidation(name) {
        let fields = this.state.Model;
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Tidak Boleh Kosong";
        }

        //Cek nama relasi bila udah ada
        else if (name != undefined) {
            formIsValid = false;
            errors["name_existed"] = "* Nama sudah ada untuk relasi tersebut";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    hapusHandler = async (_id) => {
        const respond = await CustRelationService.getById(_id)

        console.log(respond)

        this.setState({
            Mode: "Hapus Relasi",
            ShowModalDel: true
        })

        if (respond.success) {
            this.setState({
                Model: respond.result
            })
        }
    }


    render() {
        const { List, Model, ShowModal, errors, Mode } = this.state

        return (
            <div>
                <div class="container ">
                    <div class="text-center">
                        <br />
                        <h1>Hubungan Pasien</h1>
                    </div>
                    <br /><br />

                    {/* <div class="container "> */}
                    <div class="input-group col-4 mb-1 float-left ">
                        <input class="form-control rounded-left lebar" type="text" placeholder="Search by Nama" onChange={this.filterHandler("search")} />
                        <div class="input-group-append">
                            <button class="btn btn-primary rounded-right" type="button" onClick={this.loadlist}>
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>

                    <button type="button" class="btn btn-success col-2 mb-3 float-right tambah" style={{ height: 39 }} onClick={this.createHandler}><i class="fa fa-plus" ></i>       <i> </i>Tambah Relasi</button>

                    {/* </div> */}

                    {/* <div class="row justify-content-left"> */}

                    <table class="table table-striped table-sm">
                        <thead>
                            <tr class="text-center bg-primary thead-warna">

                                <th scope="col">Nama</th>
                                <th scope="col">Nama Pembuat</th>
                                <th scope="col">#</th>
                                {/* <th class="text-center">Tindakan</th> */}

                            </tr>
                        </thead>
                        <tbody>
                            {
                                List.map(data => {
                                    return (
                                        <tr class="text-center">
                                            <td class="table-primary">{data.name}</td>
                                            <td class="table-primary">{data.pembuat}</td>
                                            <td class="table-primary">
                                                <button class="btn btn-primary mr-2" onClick={() => this.editHandler(data._id)}>Ubah</button>
                                                <button type="button" class="btn btn-danger" onClick={() => this.hapusHandler(data._id)}>Hapus</button>
                                                {/* <button class="btn fa fa-pencil m-r-5" onClick={() => this.editHandler(data._id)}></button>
                                                <button type="button" class="btn fa fa-trash-o m-r-5" onClick={() => this.hapusHandler(data._id)}></button> */}

                                            </td>
                                            {/* <td class="text-center">
                                                <div class="dropdown dropdown-action">
                                                    <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
                                                    <div class="dropdown-menu dropdown-menu-right">
                                                        <a class="dropdown-item" onClick={() => this.editHandler(data._id)}><i class="fa fa-pencil m-r-5"></i>Ubah</a>
                                                        <a class="dropdown-item" data-toggle="modal" onClick={() => this.deleteHandler2()}><i class="fa fa-trash-o m-r-5"></i>Hapus</a>
                                                    </div>
                                                </div>
                                            </td> */}

                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {/* </div> */}
                    {/* <FormInput /> */}
                    <FormInput
                        changeHandler={this.changeHandler}
                        checkedHandler={this.checkedHandler}
                        saveHandler={this.saveHandler}
                        editHandler={this.editHandler}
                        Model={Model}
                        ShowModal={ShowModal}
                        createHandler={this.createHandler}
                        cancelHandler={this.cancelHandler}
                        handleValidation={this.handleValidation}
                        errors={errors}
                        Mode={Mode}

                    />
                    {/* //mengirim changeHandle ke FOrmInput */}

                    {/* <FormInput /> */}
                    <ModalHapus
                        changeHandler={this.changeHandler}
                        saveHandler={this.saveHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                    />

                    <ModalBerhasilSimpan
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        ShowModalBerhasilSimpan={this.state.ShowModalBerhasilSimpan}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />

                    <ModalBerhasilUbah
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        ShowModalBerhasilUbah={this.state.ShowModalBerhasilUbah}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />

                    <ModalHapusBerhasil
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        ShowModalDelBerhasil={this.state.ShowModalDelBerhasil}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />



                </div>



            </div>
        )
    }
}


